import { TooltipProps } from '@mui/material/Tooltip';
import { useNavigate, useLocation } from 'react-router-dom';
import { BootstrapTooltip } from '../merchants/McaStatusChip';
import { Chip } from '@mui/material';
import StatusChip from '../../components/StatusChip';
import { useTheme } from '@mui/material/styles';

type ApplicationStatusChipProps = {
  id: string;
  label: string;
  color: string;
  description: string;
  detailsPath?: string;
  navigateToDetails?: boolean;
  useCompactViewStyle?: boolean;
  mca?: boolean;
  tooltipPlacement?: TooltipProps['placement'];
  navigationState?: Record<string, any>;
};

export const ApplicationStatusChip = ({
  id,
  label,
  color,
  description,
  navigateToDetails = false,
  detailsPath = '/application',
  tooltipPlacement = 'right',
  useCompactViewStyle = false,
  mca = false,
  navigationState
}: ApplicationStatusChipProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleNavigation = () => {
    if (!navigateToDetails) return;

    const isFromFundingPipeline = location.pathname.includes('funding-pipeline');
    const state = isFromFundingPipeline ? { fromFundingPipeline: true } : navigationState;

    if (detailsPath.includes('offerId')) {
      navigate(detailsPath, { state });
      return;
    }

    if (['/applications', '/offers'].includes(detailsPath)) {
      const path = isFromFundingPipeline
        ? `/funding-pipeline?id=${id}`
        : `${detailsPath}?id=${id}`;
      navigate(path, { state });
      return;
    }

    navigate(`${detailsPath}/${id}`, { state });
  };

  return (
    <BootstrapTooltip title={description} placement={tooltipPlacement}>
      {useCompactViewStyle ? (
        <StatusChip
          sx={{
            borderRadius: '4px',
            backgroundColor: color,
            height: '20px',
            textTransform: 'uppercase',
            color: theme.palette.aliceblue.main
          }}
          label={label}
          size="small"
          variant="light"
          onClick={(e: any) => {
            e.stopPropagation();
            handleNavigation();
          }}
        />
      ) : (
        <Chip
          sx={{
            borderRadius: '4px',
            backgroundColor: color,
            height: mca ? '22px' : '20px',
            textTransform: 'uppercase',
            color: theme.palette.aliceblue.main
          }}
          label={label}
          size="small"
          variant="light"
          onClick={(e: any) => {
            e.stopPropagation();
            handleNavigation();
          }}
        />
      )}
    </BootstrapTooltip>
  );
};